import React from 'react'
import Button from '../Button/Button'
import './VideoControls.scss'

export default function VideoControls({
  showButtons,
  showVeyetalsButton,
  startVeyetals,
  isFirstScan,
  showRetry
}) {
  return (
    <div className='video-controls'>
      {showButtons && (
        <div className='video-controls__container'>
          {isFirstScan ? (
            <Button
              color='primary'
              onClick={startVeyetals}
              disabled={!showVeyetalsButton}
              text='Start Scan'
            />
          ) : (
            showRetry && (
              <Button color='secondary' onClick={startVeyetals} text='Retry' />
            )
          )}
        </div>
      )}
    </div>
  )
}
